import moment from 'moment';

export const formatStartDate = (startDate?: string, dateFormat?: string) =>
  startDate ? moment(startDate).format(dateFormat) : translate('ASAP');

export const formatEndDate = (endDate?: string, dateFormat?: string) =>
  endDate ? moment(endDate).format(dateFormat) : null;
